import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { hasPermission } from "../utils/usePermissions";
import LedgerInventoryReport from "./LedgerInventoryReport";
import LedgerVoucherReport from "./LedgerVoucherReport";
import PendingConsumablesLedger from "./PendingConsumablesLedger";

const LedgerWiseReports = ({ accessOfDepartments, permissions, accessedLedgers }) => {
  const [selectedReport, setSelectedReport] = useState("");

  /* ================= RENDER SELECTED REPORT ================= */
  const renderReport = () => {
    switch (selectedReport) {
      case "ledgerInventoryReport":
        return <LedgerInventoryReport accessOfDepartments={accessOfDepartments} accessedLedgers={accessedLedgers} />;
        case "LedgerVoucherReport":
          return <LedgerVoucherReport  permissions={permissions} accessedLedgers={accessedLedgers}/>;
        case "PendingConsumablesLedger":
          return <PendingConsumablesLedger  permissions={permissions} accessedLedgers={accessedLedgers}/>;
      default:
        return (
          <div className="text-muted mt-4">
            Please select a report
          </div>
        );
    }
  };
  const checkboxStyle = (checked) => ({
    width: "18px",
    height: "18px",
    border: "3px solid #198754",
    borderRadius: "2px",
    appearance: "none",
    cursor: "pointer",
    backgroundColor: checked ? "#198754" : "#fff",
  });

  const labelStyle = { cursor: "pointer" };

  return (
    <div className="container-fluid mt-5">
      {/* ================= HEADER ================= */}
      <div className="card">
        <div className="card-body">
          {/* <h5 className="mb-3">Ledger Wise Reports</h5> */}

          {/* ================= RADIO OPTIONS ================= */}
          <div className="row">

          {hasPermission(permissions, ['LedgerInventoryReport'])?
          <div className="col-md-4">
              <div className="form-check d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  id="ledgerInventoryReport"
                  checked={selectedReport === "ledgerInventoryReport"}
                  onChange={() => setSelectedReport("ledgerInventoryReport")}
                  style={checkboxStyle(selectedReport === "ledgerInventoryReport")}
                />
                <label htmlFor="ledgerInventoryReport" style={labelStyle}>
                Ledger Inventory Report
                </label>
              </div>
            </div>:
            null}
            
            {hasPermission(permissions, ['LedgerVoucherReport'])?
          <div className="col-md-4">
              <div className="form-check d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  id="LedgerVoucherReport"
                  checked={selectedReport == "LedgerVoucherReport"}
                  onChange={() => setSelectedReport("LedgerVoucherReport")}
                  style={checkboxStyle(selectedReport == "LedgerVoucherReport")}
                />
                <label htmlFor="LedgerVoucherReport" style={labelStyle}>
                Ledger Voucher Report
                </label>
              </div>
            </div>:
            null}

        {hasPermission(permissions, ['PendingConsumablesLedger'])?
          <div className="col-md-4">
              <div className="form-check d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  id="PendingConsumablesLedger"
                  checked={selectedReport == "PendingConsumablesLedger"}
                  onChange={() => setSelectedReport("PendingConsumablesLedger")}
                  style={checkboxStyle(selectedReport == "PendingConsumablesLedger")}
                />
                <label htmlFor="PendingConsumablesLedger" style={labelStyle}>
                Pending Consumables - Ledger
                </label>
              </div>
            </div>:
            null}
          </div>

        </div>
      </div>

      {/* ================= REPORT CONTENT ================= */}
      <div className="mt-3">{renderReport()}</div>
    </div>
  );
};

export default LedgerWiseReports;
